import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  depositMoneyPricePercentage?: number;
  purchasePrice?: number;
  propertyValue?: number;
  purchasePriceActive?: boolean;
}

export const calculateDepositMoneyPrice = (
  form: FormInstance,
  loanIndex: string | number,
  {
    depositMoneyPricePercentage = 3,
    purchasePrice,
    propertyValue,
    purchasePriceActive
  }: FieldValues = {}
): number => {
  const purchasePriceValue = purchasePrice ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'purchasePrice', 'value'])) || 0);

  const propertyValueValue = propertyValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'propertyValue'])) || 0);

  const purchasePriceActiveValue = purchasePriceActive ?? form.getFieldValue(['tableView', 'purchasePrice', 'active']);

  const price = purchasePriceActiveValue ? purchasePriceValue : propertyValueValue;

  if (!price) return 0;

  const depositMoneyPrice = (price * (depositMoneyPricePercentage / 100));

  return parseFloat(formatAmount(depositMoneyPrice)) || 0;
};
